// config.js (React version - frontend safe)
export const API_KEY = process.env.REACT_APP_API_KEY;
